import * as React from 'react'
import Category from '../../models/category'
import bind from 'bind-decorator'
import { Link, Icon, chevron } from '../../components'
import { getCategoryUrl } from './utilities'

type Props = {
    category: Category
    selectItem: (slug: string) => void
}

class CategoryListCategory extends React.Component<Props> {
    @bind
    selectItem(e: React.MouseEvent) {
        e.preventDefault()
        this.props.selectItem(this.props.category.slug)
    }

    render() {
        const { category } = this.props

        return (
            <li className='category-list__item' key={category.slug}>
                <Link
                    className='category-list__link'
                    to={getCategoryUrl(category.slug)}
                    onClick={this.selectItem}
                >
                    <span className='category-list__category-description'>
                        {category.name}
                    </span>
                    <Icon icon={chevron} className='category-list__category-chevron' />
                </Link>
            </li>
        )
    }
}

export default CategoryListCategory
